import { UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS, UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS } from "../Constants";

const initialState = {
  message: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_MANAGER_SCHEDULEHOURS_SUCCESS:
      return {
        type: "Scheduled Hours updated successfully",
        message: action.data
      };
    case UPDATE_MANAGER_WEEKLYSCHEDULE_SUCCESS:
      return {
        type: "Scheduled Hours updated successfully",
        message: action.data
      };

    default:
      return state;
  }
};
